import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

/**
 * Floating "Go up" button (bottom-right).
 * Shows after user scrolls down a bit and smoothly scrolls to top.
 */
const GoUpButton = ({ showAfter, right, bottom, label }) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    let raf = null;

    const onScroll = () => {
      // throttle via rAF (cheap + enough)
      if (raf) return;
      raf = window.requestAnimationFrame(() => {
        raf = null;
        const scrollTop =
          window.pageYOffset || document.documentElement.scrollTop || 0;
        setIsVisible(scrollTop >= showAfter);
      });
    };

    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();

    return () => {
      if (raf) window.cancelAnimationFrame(raf);
      window.removeEventListener("scroll", onScroll);
    };
  }, [showAfter]);

  const handleClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  if (!isVisible) return null;

  return (
    <button
      type="button"
      className="goUpButton"
      style={{ right, bottom }}
      onClick={handleClick}
      aria-label={label}
      title={label}
    >
      <span className="goUpButton__icon" aria-hidden="true">
        ↑
      </span>
    </button>
  );
};

GoUpButton.propTypes = {
  showAfter: PropTypes.number,
  right: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  bottom: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  label: PropTypes.string,
};

GoUpButton.defaultProps = {
  showAfter: 200,
  right: 20,
  bottom: 20,
  label: "Jít nahoru",
};

export default GoUpButton;
